export default "__VITE_ASSET__RarPQ31l__"